import script from "./Hero.vue?vue&type=script&setup=true&lang=ts"
export * from "./Hero.vue?vue&type=script&setup=true&lang=ts"

import "./Hero.vue?vue&type=style&index=0&id=792725e4&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-792725e4"]])

export default __exports__